'use strict';

angular.module('internal.trainings')
    .controller('InternalTraining', ['$scope', '$state', '$stateParams', 'Trainings', function ($scope, $state, $stateParams, Trainings) {
        $scope.masterTraining = $stateParams.training;
        $scope.training = $stateParams.training;
        $scope.trainingID = $stateParams.id;
        $scope.trainingLoading = true;
        $scope.deleting = false;

        $scope.setMasterTraining = function (training) {
            $scope.masterTraining = training;
            $scope.training = angular.copy($scope.masterTraining);
        }

        $scope.resetTraining = function () {
            if ($scope.masterTraining == null) {
                $scope.masterTraining = {};
            }
            $scope.training = angular.copy($scope.masterTraining);
        }

        $scope.getTraining = function () {
            $scope.trainingLoading = true;

            Trainings.getByID($stateParams.id).then(function (training) {
                $scope.trainingLoading = false;
                $scope.setMasterTraining(training);
            })
        }

        $scope.delete = function () {
            $scope.deleting = true;

            if (window.confirm('Are you sure you want to delete this training?')) {
                Complaints.delete($scope.trainingID).then(function () {
                    $scope.deleting = false;
                    $state.go('internal.licensing.trainings');
                })
            }
            else {
                $scope.deleting = false;
            }
        }

        if ($stateParams.id != null) {
            $scope.getTraining();
        }
        else {
            var training = {};
            $scope.trainingLoading = false;
            $scope.setMasterTraining(training);
        }
    }])
;